import { render } from "./CourseInsightsExamHeaderRenderer.vue?vue&type=template&id=53b52e08&ts=true"
import script from "./CourseInsightsExamHeaderRenderer.vue?vue&type=script&lang=ts"
export * from "./CourseInsightsExamHeaderRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__